/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { FeedQuote, FeedSpread } from '@tradingblock/types';
import { useDashboardSettings } from '../../hooks/useDashboardSettings';
import { useDispatcher } from '../global/hooks';
import { useFeedActions } from './FeedState';
import { useFeedQuoteQueue, useFeedSpreadQueue } from './FeedSelectors';

export const FeedSync: React.FC = () => {
  const { dispatcher } = useDispatcher();
  const { feedSyncIntervalMs } = useDashboardSettings();
  const quotes = useFeedQuoteQueue();
  const spreads = useFeedSpreadQueue();
  const { dropFromQueue, dropFromSpreadQueue } = useFeedActions();

  const quotesRef = useRef<FeedQuote[]>([]);
  useEffect(() => {
    quotesRef.current = quotes;
  }, [quotes]);

  const spreadsRef = useRef<FeedSpread[]>([]);
  useEffect(() => {
    spreadsRef.current = spreads;
  }, [spreads]);

  const intervalRef = useRef<NodeJS.Timeout>();
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      // Queues
      const q = quotesRef.current;
      if (q && q.length > 0) {
        const combinedQuotes: { [symbol: string]: FeedQuote } = {};
        for (let i = 0; i < q.length; i++) {
          const item = q[i];
          const prev = combinedQuotes[item.Symbol];
          if (!prev || item.QuoteTime > prev.QuoteTime) {
            combinedQuotes[item.Symbol] = item;
          }
        }
        dispatcher.feed.updateQuotes(combinedQuotes);
        dropFromQueue(q.length);
      }
      // Spreads
      const s = spreadsRef.current;
      if (s && s.length > 0) {
        const combinedSpreads: { [symbol: string]: FeedSpread } = {};
        for (let i = 0; i < s.length; i++) {
          const item = s[i];
          const prev = combinedSpreads[item.Symbol];
          if (!prev || item.SpreadTime > prev.SpreadTime) {
            combinedSpreads[item.Symbol] = item;
          }
        }
        dispatcher.feed.updateSpreads(combinedSpreads);
        dropFromSpreadQueue(s.length);
      }
    }, feedSyncIntervalMs);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [feedSyncIntervalMs]);

  return <></>;
};
